import { useEffect } from 'react';
import { Button } from "@/components/ui/button";
import { useOnboardingTour } from '@/hooks/useOnboardingTour';
import { HelpCircle, Sparkles } from 'lucide-react';
import { OnboardingTour } from './OnboardingTour';

interface OnboardingTriggerProps {
  autoStart?: boolean;
}

export function OnboardingTrigger({ autoStart = true }: OnboardingTriggerProps) {
  const { 
    isActive, 
    shouldShowTour, 
    startTour,
    hasCompleted 
  } = useOnboardingTour();

  // Auto-start tour for new users
  useEffect(() => {
    if (autoStart && shouldShowTour && !isActive) {
      // Small delay to let the page load
      const timer = setTimeout(() => {
        startTour();
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [autoStart, shouldShowTour, isActive, startTour]);

  return (
    <>
      {/* Tour overlay */}
      <OnboardingTour />
      
      {/* Manual trigger button - show if tour was completed */}
      {hasCompleted && !isActive && (
        <Button
          variant="ghost"
          size="sm"
          onClick={startTour}
          className="fixed bottom-4 right-4 z-50 gap-2 bg-card/80 backdrop-blur-sm border border-teen-cyan/20 hover:border-teen-cyan/40"
        >
          <HelpCircle className="h-4 w-4 text-teen-cyan" />
          <span className="text-xs">Take Tour</span>
        </Button>
      )}
    </>
  );
}
